var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTime = function SvgTime(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M15.41 63.62a1 1 0 1 0 1.414 1.414l7.137-7.137a1 1 0 0 0-1.414-1.414zM14.043 40.312a1 1 0 0 1 1-1h5.902a1 1 0 1 1 0 2h-5.902a1 1 0 0 1-1-1M16.38 15.41a1 1 0 1 0-1.414 1.414l7.137 7.137a1 1 0 0 0 1.414-1.414zM39.688 14.044a1 1 0 0 1 1 1v5.9a1 1 0 1 1-2 0v-5.9a1 1 0 0 1 1-1M63.62 64.59a1 1 0 1 0 1.414-1.414l-7.137-7.137a1 1 0 0 0-1.414 1.414zM40.312 65.957a1 1 0 0 1-1-1v-5.902a1 1 0 1 1 2 0v5.902a1 1 0 0 1-1 1M64.59 16.38a1 1 0 1 0-1.414-1.414l-7.137 7.137a1 1 0 0 0 1.414 1.414zM65.957 39.688a1 1 0 0 1-1 1h-5.902a1 1 0 1 1 0-2h5.902a1 1 0 0 1 1 1M33.979 27.597a1 1 0 1 0-1.725 1.011l6.938 11.83a1 1 0 0 0 .448.403l18.819 8.582a1 1 0 1 0 .83-1.82l-18.532-8.45z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M11 10a1 1 0 0 0-1 1v58a1 1 0 0 0 1 1h58a1 1 0 0 0 1-1V11a1 1 0 0 0-1-1zm1 58V12h56v56z",
    clipRule: "evenodd"
  })));
};
export default SvgTime;